var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___RENQZ2",
  "rZ": "DMWelcomeSection.module__profileSection___RENQZ2",
  "KI": "DMWelcomeSection.module__avatarButton___RENQZ2",
  "xO": "DMWelcomeSection.module__usernameButton___RENQZ2",
  "Xh": "DMWelcomeSection.module__username___RENQZ2",
  "Yh": "DMWelcomeSection.module__welcomeText___RENQZ2",
  "A2": "DMWelcomeSection.module__actionSection___RENQZ2",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___RENQZ2",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___RENQZ2",
  "$f": "DMWelcomeSection.module__guildIcon___RENQZ2",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___RENQZ2",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___RENQZ2",
};

module.exports = exports;
